export default __webpack_public_path__ + "static/media/actions.dd8fabc4.png";